
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkSetProjectToSoldAdditionalDiscountDto } from '../models/work-set-project-to-sold-additional-discount-dto';

export function getSetProjectToSoldDtoFormGroup() {
return new FormGroup({
    priceSold: new FormControl<number | undefined>(undefined, [Validators.required]),
    sale: new FormControl<string | undefined>('', [Validators.required]),
    salesinformation: new FormControl<string | undefined>(''),
    tobNotes: new FormControl<string | undefined>(''),
    installationStartFixed: new FormControl<boolean | undefined>(undefined),
    installationStart: new FormControl<string | undefined>(''),
    installationEnd: new FormControl<string | undefined>(''),
    eivFinancing: new FormControl<boolean | undefined>(undefined),
    eivFinancingAmount: new FormControl<number | undefined>(undefined),
    revenueChf: new FormControl<number | undefined>(undefined),
    discountChfIncl: new FormControl<number | undefined>(undefined),
    additionalDiscount: new FormControl<WorkSetProjectToSoldAdditionalDiscountDto | undefined>(undefined),
    revenueManual: new FormControl<boolean | undefined>(undefined),
    skontoPercentage: new FormControl<number | undefined>(undefined),
    skontoDays: new FormControl<number | undefined>(undefined),
    partialpayment1: new FormControl<number | undefined>(undefined),
    partialpayment2: new FormControl<number | undefined>(undefined),
    partialpayment3: new FormControl<number | undefined>(undefined),
    partialpayment4: new FormControl<number | undefined>(undefined),
    addedOptionalCalculationItemIds: new FormControl<Array<number> | undefined>([]),
    standardtaskgroupsToImportIds: new FormControl<Array<number> | undefined>([]),
    projectsToDeactivateIds: new FormControl<Array<number> | undefined>([]),
})
;
}
      